import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router'
import { ValidationHandler } from 'app/helpers/validation.handler';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { WorkflowStep, StepType } from 'app/models/workflow-step';
import { WorkflowStepCompletion } from 'app/models/workflow-step-completion';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import { finalize, tap, switchMap, startWith, filter, take } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss']
})
export class WFGeneralSettingsComponent implements OnInit, AfterViewInit, OnDestroy {

  tags: Tag[] = [];
  isNgSelectLoading: boolean = false;
  initialWorkflowType: string;
  onInitSubscription: Subscription = null;
  formSubmitSubject: Subject<string> = new Subject();
  
  constructor(private _validationHandler: ValidationHandler, public tagService: TagService,   
    private workflowTemplateService: WorkflowTemplateService, private _route: Router, public workflowWizardService: WorkflowWizardService, private ecoDocsTitleService: EcoDocsTitleService) {
      this.onInitSubscription = this.workflowWizardService.onInit.subscribe(()=>{
        this.initialWorkflowType = this.workflowWizardService.workflowType;
      });

      let initialStepCompletion: AbstractControl;
      this.formSubmitSubject.pipe(
        tap(()=> { 
            // Validate only the workflow name
            initialStepCompletion = this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'];
            this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] = new FormGroup({});
            this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'].updateValueAndValidity();

            this._validationHandler.onSubmitCheck(this.workflowWizardService.workflowTemplateFormGroup);
          }),
        switchMap(() =>
          this.workflowWizardService.workflowTemplateFormGroup.controls['name'].statusChanges.pipe(
            startWith(this.workflowWizardService.workflowTemplateFormGroup.controls['name'].status),
            filter(status => status !== 'PENDING'),
            take(1)
          )
        ),
      ).subscribe((status) => {
        if (status == 'VALID') {
          this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] = initialStepCompletion;
          this.onGeneralSettingsSubmit();
        } else {
          window.scroll(0,0);
          this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] = initialStepCompletion;
        }
      });
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Workflow Wizard > General Settings' , false);
    this.tagService.currentTagsSubject.subscribe(t => this.tags = t);
    this.isNgSelectLoading = false;
  }

  ngOnDestroy() {
    if (this.onInitSubscription)
      this.onInitSubscription.unsubscribe();
  }

  ngAfterViewInit() {
  }

  onGeneralSettingsSubmit() {
    
    if (this.workflowWizardService.workflowType != this.initialWorkflowType) {
      switch (this.workflowWizardService.workflowType) {
        case 'review':
          this.workflowTemplateService.createStepFormGroup(this.workflowTemplateService.initWorkflowStep(1, StepType.REVIEW), this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup);
          break;
        case 'approval':
          this.workflowTemplateService.createStepFormGroup(this.workflowTemplateService.initWorkflowStep(1, StepType.APPROVAL), this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup);
          break;
        case 'submission':
          let emptyFormGroup = new FormGroup({});
          (this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup).controls['next_step'] = emptyFormGroup;
          emptyFormGroup.setParent((this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup));
          emptyFormGroup.updateValueAndValidity();
          break;
        case 'custom':
          if ((this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup).controls['next_step'] &&
              (this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup).controls['next_step'].value &&
              (this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup).controls['next_step'].value.name) {
                // do nothing, allow it to be edited as custom
                // @note This assumes that data is valid in this step that has a name, this is not 100% accurate as editing and going back doesn't
                // trigger validation on the step
          } else {
            let emptyFormGroup = new FormGroup({});
            (this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup).controls['next_step'] = emptyFormGroup;
            emptyFormGroup.setParent((this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup));
            emptyFormGroup.updateValueAndValidity();
          }
          break;
      }
    }

    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_SECOND_STEP;
    this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_SECOND_STEP}`])   
  }
}
